<script setup lang="ts">
import { RouterLink, RouterView, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useToastStore } from '@/stores/toast'
import ToastList from '@/components/ToastList.vue'
import OnlineIndicator from '@/components/OnlineIndicator.vue'
import { useWsStore } from '@/stores/ws.ts'
import { ponyAvatar } from '@/utils/images.ts'

const auth = useAuthStore()
const router = useRouter()
const toasts = useToastStore()
const ws = useWsStore()

function logout() {
  auth.logout()
  toasts.add('Logged out successfully', 'info')
  router.push('/login')
}
</script>

<template>
  <header>
    <nav class="main-nav">
      <RouterLink to="/countdown">Countdown</RouterLink>
      <RouterLink to="/control">Control</RouterLink>
      <RouterLink to="/sessions">Sessions</RouterLink>
      <RouterLink to="/settings">Settings</RouterLink>
      <span class="spacer"></span>
      <template v-if="auth.user">
        <span class="who">
          <OnlineIndicator :online="ws.isCountdownConnected"
            >Hi, {{ auth.user.fullname || 'User' }}</OnlineIndicator
          >
          <img
            class="inline-avatar"
            :alt="`${auth.payload?.tg?.username || 'User'} Avatar`"
            :src="auth.payload?.tg?.photo_url ?? ponyAvatar()"
          />
        </span>
        <button class="link-btn" @click="logout">Logout</button>
      </template>
      <template v-else>
        <RouterLink to="/login">Login</RouterLink>
      </template>
    </nav>
  </header>
  <main>
    <RouterView />
  </main>
  <ToastList />
</template>

<style scoped lang="scss">
.main-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap; // the links, the user and Logout drop to another row on narrow screens instead of widening the page
  gap: 0.5rem 1rem;
  background: var(--color-nav-background);
  color: var(--color-text);
  padding: 1rem;
  border-bottom: 1px solid var(--color-border);
  a {
    color: var(--color-text);
    text-decoration: none;
    font-weight: 600;
    &.router-link-exact-active {
      color: var(--color-accent);
      border-bottom: 2px solid var(--color-accent);
    }
  }
  .spacer {
    flex: 1;
  }
  .link-btn {
    background: transparent;
    color: var(--color-text);
    border: 1px solid var(--color-border);
    padding: 0.4rem 0.8rem;
    border-radius: 0.5rem;
    cursor: pointer;
  }
  .who {
    color: var(--color-text);
    opacity: 0.8;
    min-width: 0;
    overflow-wrap: anywhere; // a very long display name wraps instead of pushing Logout off screen
    .inline-avatar {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      vertical-align: middle;
      margin-left: 0.3rem;
    }
  }
}
main {
  min-height: 80vh;
  background: var(--color-background-mute);
  padding-top: 1rem;
}
</style>
